export const INDEXED_DB_TIMEOUT_MS = 5000;

// A timeout of the caller alone leaves IndexedDB writes alive: they can later
// overwrite a newer draft and keep the whole per-draft queue blocked. Bound
// the actual transaction and abort it before releasing the queue. Also guard
// transactions whose callback starts only after database opening unblocks.
export function indexedDbOperation(database, mode, tables, operation, timeout = INDEXED_DB_TIMEOUT_MS) {
  return new Promise((resolve, reject) => {
    let transaction;
    let expired = false;
    const failure = () => new Error('INDEXED_DB_TIMEOUT');
    const abort = () => { try { transaction?.abort(); } catch { /* Already settled. */ } };
    const timer = setTimeout(() => {
      expired = true;
      abort();
      reject(failure());
    }, timeout);
    Promise.resolve().then(() => database.transaction(mode, tables, current => {
      transaction = current;
      if (expired) { abort(); throw failure(); }
      return operation(current);
    })).then(value => {
      if (!expired) resolve(value);
    }, error => {
      if (!expired) reject(error);
    }).finally(() => clearTimeout(timer));
  });
}
